import adminApi from "./adminApi";


export async function scanValueBets(date) {

  const { data } =
    await adminApi.post(
      `/algorithm/scan-value/${date}`
    );

  return data;

}


export async function scanTodayValueBets() {

  const { data } =
    await adminApi.post(
      "/algorithm/scan-today-value"
    );

  return data;

}